import "rsuite/dist/rsuite.min.css";
import React, { useContext, useEffect, useState, Fragment } from "react";
import localization from "assets/localization/localization";
import "../main.css";
import Layout from "components/sales/layout/layout";
import CardSection from "components/sales/cardSection/cardSection";
import "./salarymaster.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ModalPop from "components/sales/modal/modal";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const SalaryMaster = ({
  getMonthlyDataForValet,
  getValetMonthlyList = {},
  updateSalaryStatusForValet,
  history,
  match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalFailed, setIsModalFailed] = useState(false);
  const [isModalReject, setIsModalReject] = useState(false);
  const [error, setError] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [isChecked, setIsChecked] = useState([false]);
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [pageCount, setPageCount] = useState(0);

  const handleCheckboxChange = (checked, id) => {
    setSelectedItems((prevSelectedItems) => {
      const newSelectedItems = new Set(prevSelectedItems);
      if (checked) {
        newSelectedItems.add(id);
      } else {
        newSelectedItems.delete(id);
      }
      return newSelectedItems;
    });
  };

  const getMonthName = (month) => {
    const monthNames = [
      "",
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    return monthNames[month];
  };

  // useEffect(() => {
  //   (async () => {
  //     setIsLoading(true);
  //     await getMonthlyDataForValet(1);
  //     setIsLoading(false);
  //   })();
  // }, []);


  useEffect(() => {
    const fetchData = async () => {
      const filterDataSalary = JSON.parse(localStorage.getItem('filterDataSalary'));

      if (
        filterDataSalary &&
        (filterDataSalary.phone_number ||
          filterDataSalary.month ||
          filterDataSalary.year ||
          filterDataSalary.status)
      ) {
        setIsLoading(true);
        await getMonthlyDataForValet(1, null, filterDataSalary);
        setIsLoading(false);
      } else {
        setIsLoading(true);
        await getMonthlyDataForValet(1);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);



  const handleApprove = async (salaryId) => {
    const payload = {
      monthly_salary_record_id: [salaryId],
      status: "OPS_APPROVED",
    };
    setIsLoading(true);
    const res = await updateSalaryStatusForValet(payload);
    if (res.status) {
      setIsModal(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleReject = async (salaryId) => {
    const payload = {
      monthly_salary_record_id: [salaryId],
      status: "OPS_REJECTED",
    };
    setIsLoading(true);
    const res = await updateSalaryStatusForValet(payload);
    // console.log("RES TEST:", res.status);
    // return false;
    if (res.status) {
      setIsModalReject(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("filterDataSalary", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getMonthlyDataForValet(1, null, filterData, null);
    setIsLoading(false);
    filterToggle();
  };

  const handleModalHide = () => {
    setIsModal(false);
    setError(""); // Reset error state
    history.push(`${baseUrl}/salary-master`);
  };

  const handleRejectModalHide = () => {
    setIsModalReject(false);
    setError(""); // Reset error state
    window.location.reload();
  };

  const handleFailedModalHide = () => {
    setIsModalFailed(false);
    setError(""); // Reset error state
    window.location.reload();
  };

  const handleButtonClick = async () => {
    const selectedIds = Array.from(selectedItems);
    const payload = {
      monthly_salary_record_id: selectedIds,
      status: "OPS_APPROVED",
    };
    // console.log("Payload:", payload);
    // return false;
    setIsLoading(true);
    const res = await updateSalaryStatusForValet(payload);
    if (res.status) {
      setIsModal(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const onPageChange = async (val) => {
    const filterDataSalary = JSON.parse(localStorage.getItem('filterDataSalary'));
    setIsLoading(true);
    await getMonthlyDataForValet(val.selected + 1, null, filterDataSalary, null);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    setPageCount(Math.ceil(getValetMonthlyList.total / getValetMonthlyList.per_page));
    setIsLoading(false);
  }, [getValetMonthlyList] )


  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/monthly-valet-salary-report`}
          className="btn btn-primary"
        >
          {"Detailed Salary"}
        </Link>
        {selectedItems.size !== 0 && (
          <Button onClick={handleButtonClick} className="btn btn-success">
            {"Multi-approve"}
          </Button>
        )}

        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {" "}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <>
      <Layout title={localization.salaryMaster} Buttons={headerBtns} isGoback>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
        />
        <>
          {getValetMonthlyList?.resultSets?.length > 0 ? (
          <>
            <div style={{ overflowX: "auto" }}>
              <table className="table salary-master-table">
                <tr className="table-heading v1Tab salary-master-table-row">
                  <th className="salary-master-table-head">S.No.</th>
                  <th className="salary-master-table-head">Multi-select</th>
                  <th className="salary-master-table-head">Name</th>
                  <th className="salary-master-table-head">Phone Number</th>
                  <th className="salary-master-table-head">Detailed View</th>
                  <th className="salary-master-table-head">Base Salary</th>
                  <th className="salary-master-table-head">Status</th>
                  <th className="salary-master-table-head">
                    Salary Month and Year
                  </th>
                  <th className="salary-master-table-head">
                    Net Calculated Salary
                  </th>
                  <th className="salary-master-table-head">Action</th>
                </tr>

                {getValetMonthlyList?.resultSets?.map((item, index) => (
                  <>
                    <tr className="salary-master-table-row" key={index}>
                      <td className="salary-master-table-data">
                        <b>
                        {parseInt(getValetMonthlyList?.current_page) === 1 ? index+1 + '.' : 15*(parseInt(getValetMonthlyList?.current_page)-1)+(1+index)+'.'}
                        </b>
                      </td>
                      <td className="salary-master-table-data">
                        <div className="icon-styling">
                          {item.approved_salary !== 0 &&
                            item.status === "OPS_FREEZED" && (
                              <input
                                type="checkbox"
                                id={`checkbox-${item.id}`}
                                name={`checkbox-${item.id}`}
                                value={item.id}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e.target.checked,
                                    item.id
                                  )
                                }
                              />
                            )}
                        </div>
                      </td>
                      {/* <td  className="salary-master-table-data">{index + 1}</td> */}
                      <td className="salary-master-table-data">
                        {item.user_name}
                      </td>
                      <td className="salary-master-table-data">
                        {item.phone_number}
                      </td>
                      <td className="salary-master-table-data">
                        <a
                          href={`${baseUrl}/monthly-valet-salary/${item?.phone_number}/${item?.status}/${item?.month}/${item?.year}`}
                        >
                          <i className="fa fa-eye view-salary-master"></i>
                        </a>
                      </td>
                      <td className="salary-master-table-data">
                        {item.monthly_salary}
                      </td>
                      <td className="salary-master-table-data">
                        {item.status}
                      </td>
                      <td className="salary-master-table-data">
                        {getMonthName(item.month)}-{item.year}
                      </td>
                      <td className="salary-master-table-data">
                        {item.approved_salary}
                      </td>
                      <td className="salary-master-table-data">
                        <div className="icon-styling">
                          {item.approved_salary !== 0 &&
                            item.status === "OPS_FREEZED" && (
                              <i
                                className="fa fa-check view-salary-check"
                                style={{
                                  fontSize: "24px",
                                  color: "green",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleApprove(item.id)}
                              />
                            )}
                          {item.approved_salary !== 0 &&
                            item.status === "OPS_FREEZED" &&
                            item.status === "SYSTEM_CALCULATED" &&
                            item.status === "OPS_CALCULATED" && (
                              <i
                                className="fa fa-close view-salary-close"
                                style={{
                                  fontSize: "24px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleReject(item.id)}
                              />
                            )}
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
              </table>
            </div>
            <div className="d-flex" style={{fontSize:"large", justifyContent: "end"}}>
              <ReactPaginate
                nextLabel=">"
                onPageChange={onPageChange}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="<"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                forcePage={getValetMonthlyList?.currentPage}
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}

              />
            </div>
          </>
          ) : (
            <div>
              <img src={Images?.NoData} alt="" width="100%" />
            </div>
          )}
          <ModalPop
            title={"Success"}
            show={isModal}
            handleModalHide={handleModalHide}
          >
            {error ? (
              <div className="error-message">{error}</div>
            ) : (
              <div className="text-center">
                <div className="success">
                  <img src={Images?.tick} alt="" />
                </div>
                <h5>{"Salary approved successfully"}</h5>
              </div>
            )}
            <Button variant="secondary" onClick={handleModalHide}>
              OK
            </Button>
          </ModalPop>
          <ModalPop
            title={"Success"}
            show={isModalReject}
            handleModalHide={handleRejectModalHide}
          >
            {error ? (
              <div className="error-message">{error}</div>
            ) : (
              <div className="text-center">
                <div className="success">
                  <img src={Images?.tick} alt="" />
                </div>
                <h5>{"Salary rejected successfully"}</h5>
              </div>
            )}
            <Button variant="secondary" onClick={handleRejectModalHide}>
              OK
            </Button>
          </ModalPop>
          <ModalPop
            title={"Failed"}
            show={isModalFailed}
            handleModalHide={handleFailedModalHide}
          >
            {error ? (
              <div className="error-message">{error}</div>
            ) : (
              <div className="text-center">
                <div className="failed">
                  <img src={Images?.tick} alt="" />
                </div>
                <h5>{"Something went wrong"}</h5>
              </div>
            )}
            <Button variant="secondary" onClick={handleFailedModalHide}>
              OK
            </Button>
          </ModalPop>
        </>
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          salaryMasterFilter={true}
          localstorageKey={"salary_master_filter"}
        />
      </Layout>
    </>
  );
};
export default SalaryMaster;
